import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { MailingListManager } from '#mailing-list/types/mailing-list-manager.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves a list of mailing list managers from the specified API instance.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param search - Optional search string to filter mailing list managers.
 * @returns A promise resolving to an operation result containing an array of MailingListManager objects.
 * @throws Throws an error if the request fails.
 */
export const getMailingListManagers = async (instance: KyInstance, search?: string) => {
  try {
    return await instance
      .get<OperationResultWithData<MailingListManager[]>>(Uri.mailingList.managers, {
        searchParams: {
          search,
        },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
